import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames/bind'

import styles from './cart.module.css'

import CartReverseIcon from '../../icons/cartReverse'

class Cart extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  render () {
    const { user } = this.props
    const cart = user.cart
    const cartEntryCount = cart && cart.entries ? cart.entries.length : null
    let cx = classNames.bind(styles)

    return (
      <li className={styles.item}>
        <a href='/cart' className={styles.link}>
          <CartReverseIcon className={styles.icon}
            width='16px' height='16px' />
          <span className={
            cx(styles.amount,
              { hidden: (cartEntryCount === null) })
            }>
            {cartEntryCount}
          </span>
        </a>
      </li>
    )
  }
}

export default Cart



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/cart.js